export default __webpack_public_path__ + "static/media/success.2905309d.svg";